import { useClassNames } from '@common';
import { HideExpandedBigIcon, HideExpandedIcon, ShowExpandedBigIcon, ShowExpandedIcon } from '@icons';
import React, { useCallback, useState } from 'react';
import './Hide.scss';

type size = 'default' | 'big';

interface HidePropsBase {
	label: string;
	className?: string;
	defaultExpanded?: boolean;
	size?: size;
}

type HideProps = React.PropsWithChildren<HidePropsBase>;


function Hide(props: HideProps): JSX.Element {
	const {
		children,
        label,
		className,
		defaultExpanded,
		size,
	} = props;

	const [isShown, setIsShown] = useState<boolean>(defaultExpanded);

    const toggleHidden = useCallback(() => {
        setIsShown(!isShown);
    }, [isShown, setIsShown]);


	const classes = useClassNames(
		'hide',
		className,
	);

	const labelClasses = useClassNames(
		'hide__label',
		isShown ? 'hide__label_shown' : 'hide__label_hidden',
	);

	const icon = isShown 
		? (size == 'big' ? <HideExpandedBigIcon className='hide__icon' /> : <HideExpandedIcon className='hide__icon' />) 
		: (size == 'big' ? <ShowExpandedBigIcon className='hide__icon' /> : <ShowExpandedIcon className='hide__icon' />);

	return (
		<div className={classes}>
			<div className={labelClasses} onClick={toggleHidden}>
				{icon}
				<span className='hide__label-text'>{label}</span>
			</div>
			<div className="hide__content">
				{isShown ? <>{children}</> : null}
			</div>
		</div>
	);
}

const MemoisedHide = React.memo(Hide);

export {MemoisedHide as Hide};
export type {HideProps};